import { render, staticRenderFns } from "./il-wizard-step.vue?vue&type=template&id=4a8fc7fc"
import script from "./il-wizard-step.vue?vue&type=script&lang=ts"
export * from "./il-wizard-step.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports